<script>
  export let imc;

  // Função para obter a classificação do IMC
  function getClassification(imc) {
    if (imc < 18.5) return "Abaixo do peso";
    if (imc >= 18.5 && imc < 24.9) return "Peso normal";
    if (imc >= 25 && imc < 29.9) return "Sobrepeso";
    if (imc >= 30) return "Obesidade";
  }

  // Função para obter a posição da seta com base no IMC e nos intervalos específicos
  function getArrowPosition(imc) {
    const ranges = [
      { label: "Abaixo do peso", start: 0, end: 18.5, width: 25 },
      { label: "Peso normal", start: 18.5, end: 24.9, width: 25 },
      { label: "Sobrepeso", start: 25, end: 29.9, width: 25 },
      { label: "Obesidade", start: 30, end: 40, width: 25 },
    ];

    let position = 0;
    for (const range of ranges) {
      if (imc >= range.start && imc <= range.end) {
        const rangePercentage = (imc - range.start) / (range.end - range.start);
        position += rangePercentage * range.width;
        break;
      }
      position += range.width;
    }
    return position;
  }
</script>

<div class="card">
  <div class="container">
    <div class="ruler">
      <div class="zone" style="background-color: #FF0000; flex: 1 1 25%;">
        Abaixo do peso
      </div>
      <div class="zone" style="background-color: #00FF00; flex: 1 1 25%;">
        Peso normal
      </div>
      <div class="zone" style="background-color: #FFFF00; flex: 1 1 25%;">
        Sobrepeso
      </div>
      <div class="zone" style="background-color: #FF0000; flex: 1 1 25%;">
        Obesidade
      </div>
    </div>
    <div
      class="arrow"
      style="--arrow-position: {getArrowPosition(imc).toFixed(2)}%;"
    ></div>
    <div class="imc-value">IMC: {imc}</div>
    <div class="classification">{getClassification(imc)}</div>
  </div>
</div>

<style>
  .card {
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    padding: 20px;
    max-width: 600px;
    margin: 20px auto;
    text-align: center;
  }
  .ruler {
    display: flex;
    height: 30px;
    margin-bottom: 20px;
  }
  .zone {
    text-align: center;
    line-height: 30px;
    color: white;
    font-weight: bold;
  }
  .arrow {
    position: absolute;
    top: 55px; /* Ajuste a altura da seta */
    left: calc(var(--arrow-position, 0%) - 10px);
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 20px solid black; /* A seta agora aponta para baixo */
    transform: rotate(180deg); /* Rotaciona a seta 180 graus */
  }
  .imc-value {
    font-size: 2em;
    font-weight: bold;
    margin: 10px 0;
  }
  .classification {
    font-size: 1.2em;
    color: #555;
  }
</style>
